export default __webpack_public_path__ + "static/media/emptyAttributes.64782c41.svg";